/*
  Product-card layout-finpudsning. Tre uafhængige pas der kører på samme cyklus
  (load / resize / css-slider 'ready' / webfonts klar):

  1) Titler: gør titel-højden ENS PER RÆKKE (se equalizeGrid nedenfor).
  2) Add-to-cart-knapper: krymp font-size så lange oversættelser (fx tysk
     "In den Warenkorb") bliver på én linje i stedet for at wrappe (se fitButtons).
  3) Badges: krymp font-size så hele teksten er med (se fitBadges).

  --- Performance ---
  Alle DOM-reads batches FØR alle DOM-writes (undgår layout-thrashing).
  fitButtons: 1–2 forced reflows for alle knapper tilsammen — ikke 40 per knap.
  equalizeGrid: 2 forced reflows uanset antal produkter.
  fitBadges: 1 forced reflow for alle badges; kun de FÅ der reelt flyder over
  måles individuelt bagefter.
*/
(function () {
  'use strict';

  function equalizeGrid(grid) {
    var titles = grid.querySelectorAll('.product-item__title');
    if (titles.length < 2) return;

    var i;
    // 1) Batch write: nulstil til naturlig højde
    for (i = 0; i < titles.length; i++) titles[i].style.minHeight = '';

    // 2) Batch read: grupper efter visuel række (1 forced layout)
    // Skip skjulte produkter (product-item--hidden) — de er i DOM men ikke synlige,
    // og getBoundingClientRect() returnerer top:0 for dem alle → ville give forkert gruppering.
    var rows = {};
    for (i = 0; i < titles.length; i++) {
      if (titles[i].closest('.product-item--hidden')) continue;
      var top = Math.round(titles[i].getBoundingClientRect().top);
      (rows[top] = rows[top] || []).push(titles[i]);
    }

    // 3) Batch read: mål alle rækkehøjder (1 forced layout)
    var rowMaxes = {};
    for (var key in rows) {
      if (!rows.hasOwnProperty(key)) continue;
      var group = rows[key];
      var max = 0;
      for (i = 0; i < group.length; i++) {
        var h = group[i].offsetHeight;
        if (h > max) max = h;
      }
      rowMaxes[key] = max;
    }

    // 4) Batch write: sæt alle minHeight på én gang (ingen reflow her)
    for (var key2 in rows) {
      if (!rows.hasOwnProperty(key2)) continue;
      var g = rows[key2];
      for (i = 0; i < g.length; i++) {
        g[i].style.minHeight = rowMaxes[key2] + 'px';
      }
    }
  }

  // Add-to-cart-knapper: hold tekst på én linje på lange oversættelser.
  // Bruger proportional beregning (1–2 reflows totalt) i stedet for en
  // while-løkke der tvingte op til 40 reflows per knap.
  function fitButtons(grid) {
    var btns = grid.querySelectorAll('.product-item__quick-buy .button, .quick-add-to-cart .button');
    if (!btns.length) return;

    var i, span;

    // 1) Batch write: nulstil alle font-sizes
    for (i = 0; i < btns.length; i++) {
      span = btns[i].querySelector('.button__text');
      if (span) {
        span.style.removeProperty('font-size');
        span.style.whiteSpace = 'nowrap';
      }
    }

    // 2) Batch read: mål alle knapper på én gang (1 forced layout)
    var measurements = [];
    for (i = 0; i < btns.length; i++) {
      span = btns[i].querySelector('.button__text');
      if (!span || !btns[i].clientWidth) { measurements.push(null); continue; }
      measurements.push({
        span: span,
        available: btns[i].clientWidth,
        textWidth: span.scrollWidth,
        fontSize: parseFloat(getComputedStyle(span).fontSize) || 16
      });
    }

    // 3) Batch write: beregn og sæt font-size proportionalt
    // Tekst-bredde skalerer ~lineært med font-size, så én beregning er præcis nok.
    // 0.97-faktoren giver 3% margin mod pixel-runding.
    for (i = 0; i < measurements.length; i++) {
      var m = measurements[i];
      if (!m || m.textWidth <= m.available + 1) continue;
      var newSize = Math.max(10, m.fontSize * m.available / m.textWidth * 0.97);
      m.span.style.setProperty('font-size', newSize + 'px', 'important');
    }
  }

  /* ---------- Badges: hele teksten skal altid være med ----------
     .product-item__badge er nowrap + overflow:hidden + ellipsis, så lange
     oversættelser blev klippet midt i et ord på smalle kort — fx tysk
     "Sparen Sie bis zu 3,50 €" på et 2-kolonne-grid på en telefon.
     Her krympes skriften til teksten er hel; rækker gulvet (--badge-min-size)
     ikke, brydes der til max to linjer i stedet for at klippe.

     Gælder ALLE badges: temaets Liquid-badges (product-badges.liquid) og
     rabatmotorens promo-badge (qty-tiers.js), som kalder window.fitProductBadges
     når den indsætter sin badge. Promo-badgen leverer to tekstvarianter via
     data-text-full / data-text-short — den korte er uden slutdato og bruges på
     telefon-bredder, hvor der ikke er plads til den. */
  var BADGE_NARROW = '(max-width: 480px)';

  function isNarrowScreen() {
    return !!(window.matchMedia && window.matchMedia(BADGE_NARROW).matches);
  }

  // Måletilstand: --measuring slår klipningen fra, så badgen antager sin
  // NATURLIGE bredde. Nødvendigt fordi en klippet badge ikke kan måles pålideligt:
  // scrollWidth udelader slut-paddingen, og WebKit/Safari rapporterer kun den
  // synlige, ellipsis-afkortede tekst — begge svarer "teksten passer jo".
  // Klassen sættes og fjernes synkront i samme frame, så der males intet imens.
  var BADGE_MEASURING = 'product-item__badge--measuring';

  function badgeTextWidth(badge, padding) {
    badge.classList.add(BADGE_MEASURING);
    var width = badge.getBoundingClientRect().width - padding;
    badge.classList.remove(BADGE_MEASURING);
    return width;
  }

  // Skalér skriften og verificér. Tekstbredde er ikke helt lineær med font-size
  // (kerning/hinting), så der korrigeres op til 3 gange.
  function fitBadge(m) {
    var badge = m.badge;
    var size = m.size;
    var width = m.width; // allerede målt i batch-passet
    for (var i = 0; i < 3 && width > m.avail + 0.5 && size > m.min; i++) {
      size = Math.max(m.min, size * (m.avail / width) * 0.99);
      badge.style.fontSize = size + 'px';
      width = badgeTextWidth(badge, m.padding);
    }
    if (width > m.avail + 0.5) {
      badge.classList.add('product-item__badge--wrap');
      badge.style.removeProperty('font-size'); // to linjer slår mikroskopisk skrift
      fitBadgeLines(badge, m.min);
    }
  }

  // Brudt badge: krymp trinvis til teksten holder sig inden for to linjer, så
  // den ikke vokser ned over produktbilledet.
  function fitBadgeLines(badge, min) {
    var cs = getComputedStyle(badge);
    var pad = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
    var size = parseFloat(cs.fontSize) || 12;
    for (var i = 0; i < 6; i++) {
      var lineHeight = parseFloat(getComputedStyle(badge).lineHeight) || size * 1.2;
      if (badge.scrollHeight <= lineHeight * 2 + pad + 1 || size <= min) break;
      size = Math.max(min, size - 1);
      badge.style.fontSize = size + 'px';
    }
  }

  function fitBadges(root) {
    var badges = root.classList && root.classList.contains('product-item__badge')
      ? [root]
      : root.querySelectorAll('.product-item__badge');
    if (!badges.length) return;

    var i, badge;
    var narrow = isNarrowScreen();

    // 1) Batch write: tilbage til CSS-tilstand + vælg tekstvariant
    for (i = 0; i < badges.length; i++) {
      badge = badges[i];
      var text = badge.dataset[narrow ? 'textShort' : 'textFull'];
      if (text && badge.textContent !== text) badge.textContent = text;
      badge.classList.remove('product-item__badge--wrap');
      badge.style.removeProperty('font-size');
    }

    // 2) Batch read (1 forced layout): den plads hver badge HAR
    var measured = [];
    for (i = 0; i < badges.length; i++) {
      badge = badges[i];
      if (!badge.clientWidth) continue; // skjult kort — måles når det bliver synligt
      var cs = getComputedStyle(badge);
      var padding = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
      var avail = badge.clientWidth - padding;
      if (avail <= 0) continue;
      measured.push({
        badge: badge,
        size: parseFloat(cs.fontSize) || 12,
        min: parseFloat(cs.getPropertyValue('--badge-min-size')) || 8,
        padding: padding,
        avail: avail,
        width: 0
      });
    }
    if (!measured.length) return;

    // 3) Batch write + batch read (1 forced layout): den plads hver badge SKAL
    //    bruge. Måletilstanden sættes på alle på én gang, så det koster ét
    //    layout for hele grid'et frem for ét per badge.
    for (i = 0; i < measured.length; i++) measured[i].badge.classList.add(BADGE_MEASURING);
    for (i = 0; i < measured.length; i++) {
      measured[i].width = measured[i].badge.getBoundingClientRect().width - measured[i].padding;
    }
    for (i = 0; i < measured.length; i++) measured[i].badge.classList.remove(BADGE_MEASURING);

    // 4) Kun de badges der reelt er for brede krympes ("-20%", "3 for 2" passer)
    for (i = 0; i < measured.length; i++) {
      if (measured[i].width > measured[i].avail + 0.5) fitBadge(measured[i]);
    }
  }

  // qty-tiers.js kalder denne med sin nyindsatte badge
  window.fitProductBadges = fitBadges;

  function equalizeAll() {
    var grids = document.querySelectorAll('.grid');
    for (var i = 0; i < grids.length; i++) {
      if (grids[i].querySelector('.product-item__title')) equalizeGrid(grids[i]);
      if (grids[i].querySelector('.product-item')) fitButtons(grids[i]);
    }
    // Badges sidder også uden for .grid (produktsidens galleri) → hele dokumentet
    fitBadges(document);
  }

  var rafId = null;
  function schedule() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(equalizeAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);

  var resizeT = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(schedule, 150);
  });

  // css-slider genopbygger cellerne og fyrer 'ready' (bobler ikke → capture-fasen)
  document.addEventListener('ready', schedule, true);

  // Kør om når "load more"-knappen afslører nye produkter
  var loadMoreBtn = document.getElementById('collection-load-more');
  if (loadMoreBtn) loadMoreBtn.addEventListener('click', schedule);

  // Webfonts kan ændre tekst-højden efter load → mål om når de er klar
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(schedule);
  }
})();
